<script setup lang="ts">
import { useTemplateRef } from 'vue';


const { innerClasses } = defineProps({
    innerClasses: {
        type: String,
        default: ""
    }
})

const content = useTemplateRef('content')

function scrollToLast() {
    content.value.lastElementChild.scrollIntoView({
        behavior: 'smooth'
    })
}

defineExpose({
    scrollToLast
})
</script>

<template>
<div class="overflow-hidden">
    <div ref="content" class="overflow-y-auto h-full" :class="innerClasses">
        <slot></slot>
    </div>
</div>
</template>
